import { useCounts } from './useCounts';
import React, { useState } from 'react';

function Count() {

    const [period, setPeriod] = useState('day');

    const { loading, groupedCounts } = useCounts(period);
    return (
        <div>
            <div className="mb-4 flex gap-2">
                <button
                    className={`px-3 py-1 rounded border ${period === 'hour' ? 'bg-blue-500 text-white' : 'bg-white text-blue-500'}`}
                    onClick={() => setPeriod('hour')}
                >
                    Hour
                </button>
                <button
                    className={`px-3 py-1 rounded border ${period === 'day' ? 'bg-blue-500 text-white' : 'bg-white text-blue-500'}`}
                    onClick={() => setPeriod('day')}
                >
                    Day
                </button>
                <button
                    className={`px-3 py-1 rounded border ${period === 'week' ? 'bg-blue-500 text-white' : 'bg-white text-blue-500'}`}
                    onClick={() => setPeriod('week')}
                >
                    Week
                </button>
                <button
                    className={`px-3 py-1 rounded border ${period === 'biweek' ? 'bg-blue-500 text-white' : 'bg-white text-blue-500'}`}
                    onClick={() => setPeriod('biweek')}
                >
                    Biweek
                </button>
                <button
                    className={`px-3 py-1 rounded border ${period === 'month' ? 'bg-blue-500 text-white' : 'bg-white text-blue-500'}`}
                    onClick={() => setPeriod('month')}
                >
                    Month
                </button>
            </div>
            {loading 
            ? ( <p>Loading...</p> )
            :(<table className="min-w-full border border-gray-300 mt-4">
                <thead>
                    <tr>
                        <th className="border px-4 py-2">date</th>
                        <th className="border px-4 py-2">emoji</th> 
                        <th className="border px-4 py-2">count</th>
                    </tr>
                </thead>
                <tbody>
                    {groupedCounts.map(([period, emojis]) =>
                        Object.entries(emojis).map(([emoji, count]) => (
                            <tr key={`${period}-${emoji}`}>
                                <td className="border px-4 py-2">{period}</td>
                                <td className="border px-4 py-2">{emoji}</td>
                                <td className="border px-4 py-2">{count}</td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>)}
        </div>
    )
}

export default Count